(() => {
 function initNavigation(){
  const menus=[...document.querySelectorAll('.mln-menu')];
  let closeTimer, active;
  const hover=matchMedia('(hover:hover) and (pointer:fine)');
  const desktop=menu=>menu.classList.contains('mln-menu--desktop');
  function cancel(){clearTimeout(closeTimer)}
  function close(menu){if(!menu)return;menu.open=false;if(active===menu)active=null}
  function open(menu){cancel();menus.forEach(other=>{if(other!==menu)close(other)});active=menu;menu.open=true}
  function schedule(menu){cancel();closeTimer=setTimeout(()=>{if(menu.matches(':hover')||menu.contains(document.activeElement))return;close(menu)},350)}
  menus.forEach(menu=>{
   const summary=menu.querySelector(':scope > summary');
   summary.addEventListener('click',e=>{
    e.preventDefault();
    if(desktop(menu)&&hover.matches){open(menu);return}
    if(menu.open){cancel();close(menu)}else open(menu);
   });
   menu.addEventListener('pointerenter',e=>{if(desktop(menu)&&hover.matches&&e.pointerType!=='touch')open(menu)});
   menu.addEventListener('pointerleave',e=>{if(desktop(menu)&&hover.matches&&e.pointerType!=='touch')schedule(menu)});
   summary.addEventListener('pointerover',e=>{if(desktop(menu)&&hover.matches&&e.pointerType!=='touch')open(menu)});
   menu.querySelector('.mln-panel')?.addEventListener('pointerenter',cancel);
   menu.addEventListener('focusin',cancel);
   menu.addEventListener('focusout',()=>{if(desktop(menu))schedule(menu)});
   summary.addEventListener('keydown',e=>{if(e.key==='ArrowDown'){e.preventDefault();open(menu);menu.querySelector('.mln-panel a')?.focus()}});
  });
  document.addEventListener('pointerdown',e=>{if(active&&!active.contains(e.target)){cancel();close(active)}});
  document.addEventListener('keydown',e=>{if(e.key!=='Escape'||!active)return;const summary=active.querySelector(':scope > summary');cancel();close(active);summary.focus();e.preventDefault();e.stopPropagation()});
  matchMedia('(min-width:1101px)').addEventListener('change',()=>{cancel();menus.forEach(close)});
  document.querySelectorAll('.mobile-menu,.mgh-mobile-menu').forEach(drawer=>{drawer.addEventListener('toggle',()=>{if(!drawer.open)menus.filter(m=>!desktop(m)).forEach(close)})});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initNavigation,{once:true});else initNavigation();
 function revealLinkedBrand(){if(!location.hash.startsWith('#brand-'))return;const brand=document.getElementById(location.hash.slice(1));if(brand?.matches('details.mbp-brand')){brand.open=true;requestAnimationFrame(()=>brand.scrollIntoView({block:'start'}))}}
 revealLinkedBrand();window.addEventListener('hashchange',revealLinkedBrand);
})();
